import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '~/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/components/ui/select'
import { formatMonthLabel, recentMonths } from '~/pages/backoffice/admin/billing/month'

/**
 * Profondeur proposée : celle que l'API sait relire (`MAX_HISTORY_MONTHS`,
 * billing.service.ts). Au-delà, un mois listé n'aurait plus de contrepartie.
 */
const PICKER_MONTHS = 36

type Props = {
  value: string
  onChange: (month: string) => void
}

/**
 * Choix du mois observé, partagé par l'écran de facturation de l'admin et par
 * les compteurs SuperAdmin.
 *
 * La valeur reste `YYYY-MM` : le contrat avec l'API ne change pas. Seul le
 * rendu change — des mois en lettres et localisés, là où `<input type="month">`
 * affichait `2026-08` avec un style propre à chaque navigateur.
 */
function MonthPicker({ value, onChange }: Props) {
  const { t, i18n } = useTranslation()
  const months = useMemo(() => recentMonths(PICKER_MONTHS), [])

  return (
    <div className="space-y-2">
      <Label htmlFor="billing-month">{t('billing.month')}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id="billing-month" className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {months.map(month => (
            <SelectItem key={month} value={month}>
              {formatMonthLabel(month, i18n.language)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default MonthPicker
